(function ($) {
  var running = false;

  $('select[name="selectStatus"]').each(function (index) {
    var $this = $(this);

    $($this).on("change", function (ev) {
      const selectedOption = ev.target.options[ev.target.selectedIndex];
      const selectedValue = encodeURIComponent(selectedOption.value.trim());
      const selectedText = selectedOption.text;

      $("#selectedStatus").html(selectedText);
      $("#suiteSelectedStatus").html(selectedText);
      $("#popSelectedStatus").html(selectedText);

      $(".site-header__status").addClass("is-set");
      $(".site-loader").addClass("is-active");

      var data = {
        action: "ush_update_student_status",
        form: {
          studentStatus: selectedValue,
          studentStatusText: selectedText,
        },
      };

      run_ajax(data).then((response) => {
        console.log(response);
        $("#popStatus").removeClass("is-active");
        $(".tooltip__spot").css({ display: "none" });

        update_site_content();
      });
    });
  });

  $('select[name="selectYearStatus"]').on("change", function (ev) {
    const yearOption = ev.target.options[ev.target.selectedIndex];
    const yearValue = encodeURIComponent(yearOption.value.trim());
    const yearText = yearOption.text;

    $("#suiteYearSelected").html(yearText);
    console.log(yearValue);

    $(".site-loader").addClass("is-active");

    var data = {
      action: "ush_update_student_year",
      form: {
        yearStatus: yearValue,
        yearStatusText: yearText,
      },
    };

    run_ajax(data).then((response) => {
      console.log(response);

      update_site_content();
    });
  });

  function run_ajax(data) {
    return $.post(theme_ajax.ajaxurl, data).then(function (response) {
      if (response.length) {
        console.log(response);
      }

      const currentPath = window.location.pathname.replace(/^\/|\/$/g, ""); // remove leading/trailing slashes
      const clearCacheUrl = `${window.location.origin}/kinsta-clear-cache/${currentPath}/`;

      return fetch(clearCacheUrl, {
        method: "GET",
        credentials: "same-origin",
      }).then((response) => {
        return response;
      });
    });
  }

  function update_site_content() {
    /**
     * Can't run fetch multiple times as the page cache
     * and scripts are removed and a rebounding method
     * should be called.
     */
    location.reload();

    // fetch(window.location.href, {
    //   method: "GET",
    //   headers: { "X-Requested-With": "XMLHttpRequest" },
    // })
    //   .then((response) => response.text())
    //   .then((html) => {
    //     const parser = new DOMParser();
    //     const doc = parser.parseFromString(html, "text/html");
    //     const newContent = doc.querySelector("#page");
    //     const oldContent = document.querySelector("#page");

    //     oldContent.innerHTML = newContent.innerHTML;
    //   });
  }

  $("form.faq-form").on("change", function (ev) {
    $(".site-loader").addClass("is-active");
    const formData = $(this).find(':not([type="hidden"])').serialize();

    const text = $(ev.target).find("option:selected").text();
    const span = $(ev.target).closest("div").find("span").first();

    $(span[0]).text(text);

    fetch(theme_ajax.ajaxurl, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        action: "ush_retrieve_faqs",
        form: formData,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        const container = $("#accordionPosts");
        container.html(JSON.parse(data.data));

        if (window.cavAccordionInit) {
          window.cavAccordionInit(container);
        }
      })
      .catch((err) => {
        console.error("FAQ Retrieval error: ", err);
      })
      .finally(() => {
        $(".site-loader").removeClass("is-active");
      });
  });
})(jQuery);
